export default "__VITE_ASSET__D9ba0lZQ__"